import React from 'react';
import { AppManager, userSession$ } from 'top-app-manager';
import 'top-app-manager/dist/index.css';
import { authConfig } from '.';

class Dashboard extends React.Component {
    state = {
        apps: [],
        session: null
    }

    componentDidMount() {
        fetch('/assets/apps.json').then(response => response.json() )
            .then(response => {
                this.setState({apps: response.apps})
            })

            userSession$.subscribe(session => {
                this.setState({session: session})
            });
    }

    public render(): JSX.Element {
        let session = this.state.session;
        let groups = [];
        if(session) {
            groups = session['cognito:groups'];
        }
        return (
            <div className='dashboard'>
                <AppManager config={authConfig} />

                {session !== null ? 
                <>
                    <h1>Welcome back!</h1>
                    <label>Choose an application to continue</label>
                    <ul className="apps">
                        {this.state.apps.map((app: any, i: number) => 
                            <>
                            {(!app.role || app.role.length === 0 || groups.filter(itm => app.role.includes(itm) ).length > 0) && (
                            <li key={`app_key_${i}`}>
                                <a href={app.url} target={app.newWindow? '_blank':''}>
                                    <span className="icon">
                                        <img alt="" src={app.logoURL} />
                                    </span>
                                    <strong>{app.name}</strong>
                                </a>
                            </li>
                            )}
                            </>
                        )}
                    </ul>
                </>
                : null}
            </div>
        )
    }
}

export default Dashboard